export const STAGE_WIDTH = 1920;
export const STAGE_HEIGHT = 1080;
// Contrast checked against the day gradient (#5c2723 centre, #261312 edge) and night (#1a1b26, #0f1015):
// text tokens stay >= 4.5:1 on the day centre, markers >= 3:1. Red reads as nothing on the burgundy day,
// so "look here" is amber and red is kept (lightened) only for losses: deaths, the 3rd foul, mafia.
export const colors = {
    text: '#EDE6DA',
    muted: '#A89F93',
    soft: '#B8AFA3',
    mark: '#D9D1C4',
    pass: '#A0968A',
    // Ivory at low alpha follows the background instead of turning into a dark groove on the red day
    line: 'rgba(237,230,218,0.3)',
    rowLine: 'rgba(237,230,218,0.12)',
    // Active player, timers, vote leader, round starter
    accent: '#F2B33D',
    // Dark text on accent fills
    ink: '#1A0E0C',
    activeRow: '#F2B33D',
    danger: '#FF7A66',
    // Third foul on an accent (active) row
    dangerOnAccent: '#8A1F14',
    inkFaint: 'rgba(26,14,12,0.3)',
    night: '#9AA6CC',
    fools: '#F2B33D',
    letterbox: '#0A0808',
};
export const backgrounds = {
    // Day must read as clearly lighter and warmer than night from across the room
    day: 'radial-gradient(ellipse 70% 90% at 25% 40%, #5c2723 0%, #261312 75%)',
    night: 'radial-gradient(ellipse 60% 80% at 25% 45%, #1a1b26 0%, #0f1015 75%)',
    pair: 'radial-gradient(ellipse 70% 70% at 30% 50%, #241c1a 0%, #131010 70%)',
};
export const fonts = {
    serif: "'Cormorant Garamond', 'Times New Roman', serif",
    sans: "'Manrope', 'Segoe UI', sans-serif",
    logo: "'TuesdayNight', cursive",
};
export const GOOGLE_FONTS_HREF = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,500;0,600;1,500&family=Manrope:wght@400;500;700&display=swap';
